import http from './http-service'
import config from '../config/constant'
import moment from 'moment'
import uuid from 'uuid'

const dateFormat2 = (date) => {
  const selectedDate = new Date(date)
  const dd = selectedDate.getDate()
  const mm = selectedDate.getMonth() + 1
  const yyyy = selectedDate.getFullYear()
  const convertedDate = `${yyyy}-${mm < 10 ? '0' + mm : mm}-${dd < 10 ? '0' + dd : dd}`
  return convertedDate
}

const getAccountDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.portfolio.getAccountDetails, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const createAccountNickName = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'ACCOUNTNICKNAME',
    }
    const response = await http.post(config.portfolio.createAccountNickName, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getCASADetails = async (data) => {
  try {
    const reqParams = {
      accountNo: data.accountNo,
      brnCode: data.brnCode,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.portfolio.getCASAAccountDetails, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getLoanDetails = async (data) => {
  try {
    const reqParams = {
      loanAccountNo: data.accountNo,
      loanAccBrn: data.brnCode,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.portfolio.getLoanAccountDetails, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getLoanStatement = async (data) => {
  try {
    const reqParams = {
      loanAccountNo: data.accountNo,
      loanAccBrn: data.brnCode,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.portfolio.getLoanAccountStatement, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getDepositDetails = async (data) => {
  try {
    const reqParams = {
      accountNo: data.accountNo,
      brnCode: data.brnCode,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.portfolio.getDepositAccountDetails, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getDepositeStatement = async (data) => {
  try {
    const reqParams = { 
      srcAccount: data.accountNo,
      brnCode: data.brnCode,
      requestId: 'VIEWDEPOSITSTATEMENT',
    }
    const response = await http.post(config.portfolio.getDepositAccountStatement, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const topTenTxn = async (data) => {
  try {
    const reqParams = {
      accountNo: data.accountNo,
      requestId: 'ACCOUNTDETAILS',
    }
    const response = await http.post(config.portfolio.getAccountMiniStatement, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getListOfFormat = async (data) => {
  try {
    const reqParams = {
      requestId: 'FORMATLIST',
    }
    const response = await http.post(config.portfolio.getListOfFormat, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getMT103RefNumbers = async (data) => {
  try {
    const reqParams = {
      ...data,
      contractRefNo: '',
      contractRef: data.contractRef,
      fromDate: dateFormat2(data.fromDate),
      toDate: dateFormat2(data.toDate),
      requestId: 'MT103MESSAGE',
    }
    const response = await http.post(config.portfolio.getMT103RefNumbers, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

export function showFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/pdf' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.pdf`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function showXlsxFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/xlsx' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.xlsx`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

export function showCSVFile(blob, fileName) {
  console.log(blob)
  const newBlob = new Blob([blob], { type: 'application/csv' })
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }
  const data = window.URL.createObjectURL(newBlob)
  const link = document.createElement('a')
  link.href = data
  link.download = `${fileName}.csv`
  link.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(data)
  }, 100)
}

const biStatement = async (data) => {
  try {
    const reqParams = {
      accountNo: data.accountNo,
      format: data.format,
      fromDate: moment(data.fromDate).format('DD-MM-YYYY'),
      reportName: data.reportName,
      toDate: moment(data.toDate).format('DD-MM-YYYY'),
      requestId: 'BISTATEMENT',
    }
    const response = await http.post(config.portfolio.bistatement, reqParams, {
      responseType: 'arraybuffer',
    })

    if (data.format === 'pdf') {
      showFile(response.data, data.reportName)
    } else {
      showXlsxFile(response.data, data.reportName)
    }
    return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}

const getAccountFullStatement = async (data) => {
  try {
    const reqParams = {
      accountNo: data.accountNo,
      brnCode: data.brnCode,
      fromDate: dateFormat1(data.fromDate),
      toDate: dateFormat1(data.toDate),
      requestId: 'FULLSTATEMENT',
    }
    const response = await http.post(config.portfolio.getAccountFullStatement, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getMt103receipt = async (data) => {
  try {
    console.log('data is', data)
    const reqParams = {
      contractRefNo: data,
      requestId: 'MT103MESSAGE',
    }
    console.log(reqParams)
    const response = await http.post(config.userActions.getMt103receipt, reqParams, {
      responseType: 'blob',
    })
    showFile(response.data, `Statement-${data}`)
    // showFile(response.data)
    //return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}

const getPDFFullStatement = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'FULLSTATEMENT',
    }
    const transactionList = await http.post(config.userActions.downloadStatement, reqParams, {
      responseType: 'arraybuffer',
    })
    if (data.format === 'PDF') {
      showFile(transactionList.data, 'pdfStatement_' + uuid.v4())
    } else if (data.format === 'EXCEL') {
      showXlsxFile(transactionList.data, 'Statement_' + uuid.v4())
    } else {
      showCSVFile(transactionList.data, 'Statement_' + uuid.v4())
    }
    return { status: transactionList.status }
  } catch (err) {
    return Promise.reject(err)
  }
}

const dateFormat = (date) => {
  const selectedDate = new Date(date)
  const dd = selectedDate.getDate()
  const mm = selectedDate.getMonth() + 1
  const yyyy = selectedDate.getFullYear()
  const convertedDate = (dd < 10 ? '0' + dd : dd) + '-' + (mm < 10 ? '0' + mm : mm) + '-' + yyyy
  return convertedDate
}

const dateFormat1 = (date) => {
  const selectedDate = new Date(date)
  const dd = selectedDate.getDate()
  const mm = selectedDate.getMonth() + 1
  const yyyy = selectedDate.getFullYear()
  const convertedDate = yyyy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd)
  return convertedDate
}

const PortfolioService = {
  getAccountDetails,
  getCASADetails,
  topTenTxn,
  getListOfFormat,
  biStatement,
  getAccountFullStatement,
  createAccountNickName,
  getMT103RefNumbers,
  getMt103receipt,
  getLoanDetails,
  getLoanStatement,
  getDepositeStatement,
  getDepositDetails,
  getPDFFullStatement,
}

export default PortfolioService
